/* eslint-disable arrow-body-style  */
import { getBudgetService } from '../../services/yclickMaster';
import {
  getMultipleDraft as getMultipleDraftService,
  deleteDraft as deleteDraftService,
  postCreateMultipleServiceRequest as postCreateMultipleServicerequestService,
  updateMultipleDraft as updateMultipleDraftService
} from '../../services/serviceRequest';
import {
  getTemplateRequest,
  replicateTemplateRequest
} from '../../services/templateServiceRequest';
import { imputationTypeEnum, ubicationTypeEnum } from '../../utils/dataStatus';

import {
  draftResponseAdapter,
  createMultipleServiceRequestAdapter
} from './createServiceRequestUtils';

const postCreateMultipleRequest = async (
  params,
  deletedServices,
  idSDSToReply,
  isApplyTemplateRequest
) => {
  const paramsAfter = createMultipleServiceRequestAdapter(
    params,
    idSDSToReply,
    isApplyTemplateRequest,
    deletedServices
  );
  const response = await postCreateMultipleServicerequestService(paramsAfter);

  return response;
};

// isDraw is only added if we are generating a template from a draft.
// If it's the normal draft view, we don't need to pass isDraw.
// isEditTemplate is used when we are editing a template, but it will also be useful
// when we apply a template, since we will be fetching the template data.
const getMultipleDraft = async (
  id,
  isReplyRequest = false,
  isEditTemplate = false,
  isDraw = false,
  isApplyTemplateRequest = false
) => {
  try {
    let data;

    if (!isReplyRequest && !isEditTemplate && !isApplyTemplateRequest) {
      data = await getMultipleDraftService(id);
    } else if (!isEditTemplate && isReplyRequest) {
      data = await replicateTemplateRequest(id);
    } else if (isEditTemplate || isApplyTemplateRequest) {
      data = await getTemplateRequest(id);
    }
    const isOyM =
      data?.ubicacion?.tipoUbicacion?.id !== ubicationTypeEnum.pozo &&
      data?.ubicacion?.tipoUbicacion?.id !== ubicationTypeEnum.locacion;

    const resBudget = await Promise.all(
      data?.ubicacion?.pozos?.map((pozo) =>
        pozo.tipoImputacion.id === imputationTypeEnum.PEP
          ? getBudgetService(pozo.objetoImputacion.id)
          : null
      )
    ).catch(() => []);

    return draftResponseAdapter(
      data,
      resBudget,
      isReplyRequest,
      isEditTemplate,
      isDraw,
      isApplyTemplateRequest,
      isOyM
    );
  } catch (err) {
    throw new Error(err?.message);
  }
};

const deleteDraft = async (id) =>
  new Promise((resolve, reject) => {
    deleteDraftService(id)
      .then((data) => {
        resolve(data);
      })
      .catch((err) => reject(err));
  });

const updateMultipleDraft = (gsdsNumber, params, deletedServices = []) => {
  const paramsAfter = createMultipleServiceRequestAdapter(params, null, false, deletedServices);

  return updateMultipleDraftService(gsdsNumber, paramsAfter);
};

/**
 * @param {{data: {id: number, nombre: string}[], statusCode: number, message: string}} data
 * @returns {{id: number, label: string, nombre: string, value: number}[]}
 */
export const getInspectorsAdapter = ({ data }) => {
  return data.map((inspector) => ({
    ...inspector,
    label: inspector.nombre,
    value: inspector.id
  }));
};

export { deleteDraft, getMultipleDraft, postCreateMultipleRequest, updateMultipleDraft };
